// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"94182e49","86":"94182e49","90":"94182e49","248":"94182e49","820":"94182e49"}[chunkId] + ".chunk.css";
};